import {
    get
} from "@/network/request.js";

export const fetchOptions = (p) => get("general/option", p);
export const fetchArticleList = (p) => get("article/index", p);
export const fetchArticleDetail = (p) => get("article/detail/" + p, {});
export const fetchBookList = (p) => get("book/index", p);
export const fetchBookDetail = (p) => get("book/detail/" + p, {});
export const fetchCityStats = (p) => get("article/cityStats", p);